export default function ($log, $rootScope, $state, $anchorScroll, $window, visitedPagesService) {
  'ngInject';
  $rootScope.$on('$locationChangeSuccess', function ($event, next, current) {
    $anchorScroll();

    if( next !== current) visitedPagesService.addPageToCounter();
  });

  // document.addEventListener('resume', requestAccessToken, false);

  // TODO: [Manu]: si fuera necesario añadir refrescar el token cuando la APP regresa de segundo plano
  // function requestAccessToken() {
  // }
}



// WEBPACK FOOTER //
// ./client/app/app.run.mobile.js